import { createRouter, createWebHistory } from "vue-router";
import { useAccountStore } from "@/stores/account";
import Auth from '@/pages/Auth.vue'
import Home from '@/pages/Home.vue'
import Empty from '@/pages/Empty.vue'
import Analitics from '@/pages/Analitics.vue'
import RoadMap from '@/pages/RoadMap.vue'
import Account from '@/pages/Account.vue'
import Trackers from '@/pages/Trackers.vue'
import TrackersList from '@/pages/TrackersList.vue'
import TrackersSupervising from '@/pages/TrackersSupervising.vue'
import Program from '@/pages/Program.vue'
import TeamReports from '@/pages/TeamReports.vue'
import Feedbacks from '@/pages/Feedbacks.vue'
import FeedbackForm from '@/pages/FeedbackForm.vue'
import PageNotFound from '@/pages/PageNotFound.vue'
import SupervisorPage from '@/pages/SupervisorPage.vue'
import StudentMarks from '@/pages/StudentMarks.vue'

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/auth", component: Auth, name: "auth" },
    { path: "/fb/:id", component: FeedbackForm, name: "fb" },
    { path: "/", component: Home, children: [
      { path: "/", component: Empty },

      { path: "/account", component: Account },
      { path: "/trackers", component: Trackers, children: [
        { path: "", component: TrackersList },
        { path: "supervising", component: TrackersSupervising }
      ] },
      { path: "/supervising/:programId", component: SupervisorPage },
      { path: "/feedback", component: Feedbacks },

      { path: "/programs/:programId", component: Program, children: [
        { path: "", component: Analitics, name: "analitics" },
        { path: "roadmap", component: RoadMap, name: "roadmap" },
        { path: "reports", component: TeamReports, name: "reports" },
        { path: "students", component: StudentMarks, name: "student-marks" }
      ] },
      { path: "/teams/:teamId/reports", component: TeamReports }
    ] },
    { path: "/:pathMatch(.*)*", component: PageNotFound, name: "404" }
  ]
})

router.beforeEach(async (to) => {
  const accountStore = useAccountStore()
  if (accountStore.status === "not-authorized" && to.name !== "auth" && to.name !== "fb") {
    return "/auth"
  }
  
  if (accountStore.currentUser && !accountStore.currentUser?.isDirector && to.name === "analitics") {
    return { name: "reports", params: to.params }
  }
})